/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserResponse
 */
export interface RevisdomAPIViewModelsUserResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    role?: RevisdomAPIViewModelsUserResponseRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    notificationToEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserResponse
     */
    lastLoginAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsUserResponseRoleEnum = {
    Admin0: 'Admin (0)',
    Editor1: 'Editor (1)',
    Commenter2: 'Commenter (2)',
    Viewer3: 'Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsUserResponseRoleEnum = typeof RevisdomAPIViewModelsUserResponseRoleEnum[keyof typeof RevisdomAPIViewModelsUserResponseRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsUserResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserResponse(value: object): value is RevisdomAPIViewModelsUserResponse {
    return true;
}

export function RevisdomAPIViewModelsUserResponseFromJSON(json: any): RevisdomAPIViewModelsUserResponse {
    return RevisdomAPIViewModelsUserResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'title': json['title'] == null ? undefined : json['title'],
        'role': json['role'] == null ? undefined : json['role'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'notificationToEmail': json['notificationToEmail'] == null ? undefined : json['notificationToEmail'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
    };
}

export function RevisdomAPIViewModelsUserResponseToJSON(json: any): RevisdomAPIViewModelsUserResponse {
    return RevisdomAPIViewModelsUserResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserResponseToJSONTyped(value?: RevisdomAPIViewModelsUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'title': value['title'],
        'role': value['role'],
        'organizationName': value['organizationName'],
        'thumbnailUrl': value['thumbnailUrl'],
        'notificationToEmail': value['notificationToEmail'],
        'isActive': value['isActive'],
        'isDeleted': value['isDeleted'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'lastLoginAt': value['lastLoginAt'] == null ? undefined : ((value['lastLoginAt'] as any).toISOString()),
    };
}

